import React from 'react';
import { Modal } from '../basic';
import RosterUpload from './RosterUpload';

interface RosterUploadModalProps {
  isOpen: boolean;
  onClose: () => void;
  onUploadComplete?: () => void;
}

const RosterUploadModal: React.FC<RosterUploadModalProps> = ({ isOpen, onClose, onUploadComplete }) => {
  const handleUploadComplete = () => {
    if (onUploadComplete) {
      onUploadComplete();
    }
    // Don't automatically close - let the user close via result modal
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} maxWidth="2xl">
      <RosterUpload onUploadComplete={handleUploadComplete} onClose={onClose} />
    </Modal>
  );
};

export default RosterUploadModal;
